import React from 'react';

// Components
import SidebarTitle from '../SidebarTitle/SidebarTitle';

// Styles
import './SidebarMapLegend.scss';

function SidebarMapLegend({ mapLegendRef }: { mapLegendRef: React.MutableRefObject<null> }) {
  return (
    <div className='SidebarMapLegend__container admin-2-estimates__sidebar-legend'>
      <SidebarTitle title={'LEGEND'} />
      <div ref={mapLegendRef} className='MapLegend' />
    </div>
  );
}

export default SidebarMapLegend;
